import React from 'react';

const VARIANTS = {
  default: { bg: '#EDEAE3', color: '#1A1A1A' },
  success: { bg: '#E8F5EE', color: '#2D7A4A' },
  warning: { bg: '#FFF4D6', color: '#B8860B' },
  danger:  { bg: '#FDEAE5', color: '#C8442A' },
  info:    { bg: '#FFF5F0', color: '#E8502A' },
};

export default function PillBadge({ label, variant = 'default', style }) {
  const v = VARIANTS[variant] || VARIANTS.default;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: v.bg,
        color: v.color,
        fontSize: 12,
        fontWeight: 600,
        padding: '4px 10px',
        borderRadius: 999,
        letterSpacing: '0.01em',
        ...style,
      }}
    >
      {label}
    </span>
  );
}
